export const langKeys = {
  accept_terms_of_service_web: "accept_terms_of_service_web",
  create_an_account: "create_an_account",
  email: "email",
  forgot_password: "forgot_password",
  marketing_consent: "marketing_consent",
  password: "password",
  password_too_long: "password_too_long",
  password_too_short: "password_too_short",
  password_too_weak: "password_too_weak",
  placeholder_web: "placeholder_web",
  privacy_policy: "privacy_policy",
  sign_in: "sign_in",
  sign_in_no_account: "sign_in_no_account",
  terms_of_service: "terms_of_service",
} as const

export type LangType = {
  accept_terms_of_service_web: "I have read and accept the <tos>Terms of Service</tos> and <privacy>Privacy Policy</privacy> and consent to the processing of personal data in the USA"
  create_an_account: "Create an account"
  email: "Email"
  forgot_password: "Forgot your password?"
  marketing_consent: "Yes please, keep me updated with Minut news, events and offers."
  password: "Password"
  password_too_long: "Password length must be shorter than 50"
  password_too_short: "Password length must be at least 8"
  password_too_weak: "Password too weak"
  placeholder_web: "{{text}}"
  privacy_policy: "Privacy Policy"
  sign_in: "Sign in"
  sign_in_no_account: "Don't have a Minut account?"
  terms_of_service: "Terms of Service"
}

export type LangArguments = {
  placeholder_web: {
    text: Date | string | number | null | undefined
  }
}
